export const path = {

  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  UPDATE_PASSWORD: "/update-password",

  CONFIG: "/config",

  COMPANIES: "/companies",
  COMPANY_DETAILS: "/company/:id",

  MEMBERS: "/members",
  MEMBER_DETAILS: "/members/:id",
  MY_PROFILE: "/my-profile",

  VISITOR_DETAILS: "/visitors/:type/:id",

  VEHICLES: "/vehicles",
  WHATSAPP: "/whatsapp",
  MESSAGE_HISTORY: "/message-history",
  MESSAGE_ANNIVERSARIES: "/message-anniversaries",
  MESSAGE_TRANSACTIONS: "/message-transactions",
  MESSAGE_TRANSACTION_DETAILS: "/message-transactions/:id",
  MESSAGE_RECENT: "/recent-messages",
  MESSAGING: "/messaging",
  MESSAGING_EMERGENCY_ALERT: "/messaging-emergency-alert",
  BIBLE_VERSES: "/bible-verses",
  USERS: "/users",
  REQUESTS: "/requests",
  STREAM_VEHICLE: "/stream_vehicle",
  BLOCK: "/block",
  VISITORS: "/visitors",
  GROUPS: "/groups",
  TEAMS: "/teams",
  APPARTMENTS: "/appartments",
  CAMERAS: "/cameras",
  NODES: "/nodes",
  AUDIT: "/audit",
  ZONES: "/zones",
  MARRIAGES: "/marriages",
  RELATIONSHIPS: "/relationships",
  FAMILY_TREE_VIEW: "/family-tree-view",
  FAMILIES: "/families",
  LOCATIONS: "/locations",
  BIBLE_MANAGEMENT: "/bible-management",
  BIBLE_VERSE_OCCASION: "/bible-verse-occasion",
  OCCASION_VERSES: "/verses-management-occasion",
  ROLES: "/roles",
  MASTER_DATA: "/master-data",
  CAMPUSES: "/campuses",
  CAMPUS_NODES: "/campuses/:campusId/nodes",
  CAMPUS_NODE_DETAIL: "/campuses/:campusId/nodes/:nodeId",
  VISUALS: "/visuals",
  VEHICLE_LOGS: "/vehicle-logs",
  VEHICLE_LOGS_LIVE: "/vehicle-logs/live",
  VEHICLE_LOGS_HISTORY: "/vehicle-logs/history",
  VEHICLE_LOGS_SEARCH: "/vehicle-logs/search",
  
















}